export default "__VITE_ASSET__37d26d2a__"